import { message } from "antd";
import Router from "../..";
import { handleApiError } from "./indexApi";

const BASE_URL = process.env.REACT_APP_API_URL_PRO;

export const companyApi = {
  getInvitedMembers: async () => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/company/get/invited`,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "초대된 멤버 목록 조회에 실패했습니다.");
      return null;
    }
  },

  inviteMember: async (email) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/company/member/invite`,
        { user_email: email },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("멤버 초대가 완료되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "멤버 초대에 실패했습니다.");
      return false;
    }
  },

  cancelInvitedMembers: async (id) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/company/invite/cancel`,
        { id },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        message.success("초대가 취소되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "초대 취소가 실패되었습니다.");
      return false;
    }
  },

  getMembers: async () => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/company/get/members`,
        {
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "브랜드 멤버 목록 조회에 실패했습니다.");
      return null;
    }
  },

  updateMemberGrade: async ({ user_id, grade }) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/company/update/grade`,
        { user_id, grade },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      return !!data.result;
    } catch (err) {
      return false;
    }
  },

  // 브랜드 삭제
  deleteBrand: async () => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/company/delete`,
        {},
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        localStorage.setItem("authorization", data.result.authorization);
        localStorage.setItem("rauthorization", data.result.rauthorization);
        message.success("브랜드가 삭제되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "브랜드 삭제에 실패했습니다.");
      return false;
    }
  },

  // 브랜드 생성
  createBrand: async ({
    company_name,
    industry,
    registration_number,
    registration_img,
  }) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/company/create`,
        { company_name, industry, registration_number, registration_img },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        localStorage.setItem("authorization", data.result.authorization);
        localStorage.setItem("rauthorization", data.result.rauthorization);
        message.success("브랜드가 생성되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "브랜드 생성에 실패했습니다.");
      return false;
    }
  },

  // 브랜드 탈퇴하기
  leaveBrand: async () => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/company/leave`,
        {},
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        localStorage.setItem("authorization", data.result.authorization);
        localStorage.setItem("rauthorization", data.result.rauthorization);
        message.success("해당 브랜드를 떠났습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "브랜드 탈퇴하기에 실패했습니다.");
      return false;
    }
  },

  // 나의 초대받은 내역 조회
  getInvitedHistoryByBrand: async () => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/company/get/invitation`,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      return res.data;
    } catch (err) {
      handleApiError(err, "나의 초대받은 내역 조회에 실패했습니다.");
      return false;
    }
  },

  // 초대받은 브랜드 수락
  acceptInvitation: async (company_id) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/company/accept/invite`,
        { company_id },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        localStorage.setItem("authorization", data.result.authorization);
        localStorage.setItem("rauthorization", data.result.rauthorization);
        message.success("브랜드 초대가 수락되었습니다.");
        return true;
      }
      if (data.error?.text)
        message.error(
          "현재 워크스페이스에 가입된 유저입니다. 브랜드 탈퇴 후 수락해주세요"
        );
      return false;
    } catch (err) {
      handleApiError(err, "브랜드 초대 수락에 실패했습니다.");
      return false;
    }
  },

  // 브랜드 통장 사본 추가
  addBankAccountByCompany: async (
    bank_holder_name,
    bank_account_url,
    bank_account_number,
    bank_name
  ) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/company/add/bank`,
        { bank_holder_name, bank_account_url, bank_account_number, bank_name },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      return data.result;
    } catch (err) {
      handleApiError(err, "통장 사본 추가에 실패했습니다.");
      return false;
    }
  },
};
